import { Ingredient } from "@/db/index.server";
import { updateUserIngredient } from "@/lib/ingredients/mutations.server";
import type { IngredientWritePatch } from "@/lib/ingredients/serialization.server";
import { requireSessionUser } from "@/lib/serverAuth";
import * as Sentry from "@sentry/cloudflare";
import { createServerFn } from "@tanstack/react-start";

type UpdateIngredientParams = IngredientWritePatch;

export const updateIngredient = createServerFn({ method: "POST" })
  .inputValidator(
    (data: { ingredientId: number; updates: UpdateIngredientParams }) => data,
  )
  .handler(async ({ data }): Promise<Ingredient> => {
    const user = await requireSessionUser();

    try {
      return await updateUserIngredient({
        patch: data.updates,
        selector: { id: data.ingredientId },
        userId: user.id,
      });
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);
      throw new Error("Failed to update ingredient");
    }
  });
